import { render, staticRenderFns } from "./CreateExpense.vue?vue&type=template&id=f16a93d2&scoped=true&"
import script from "./CreateExpense.vue?vue&type=script&lang=js&"
export * from "./CreateExpense.vue?vue&type=script&lang=js&"
import style0 from "./CreateExpense.vue?vue&type=style&index=0&id=f16a93d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16a93d2",
  null
  
)

export default component.exports